const { TextControl, Panel, PanelBody, Button, IconButton } = wp.components;

export const TagsArrayRepeater = ( {props, attributeKey, label} ) => {

    if (props == undefined) {
        return null;
    }

    var repeaterFields;

    const handleRepeaterFieldChange = (text, index) => {
        const repeaterFields = [...props.attributes[attributeKey]];
        repeaterFields[index] = { ...repeaterFields[index], label: text };
        props.setAttributes({ [attributeKey]: repeaterFields });
    };
    
    const handleAddRepeaterField = () => {
        const repeaterFields = [...props.attributes[attributeKey]];
        repeaterFields.push({ label: '', tags: [] });
        props.setAttributes({ [attributeKey]: repeaterFields });
    };
    
    const handleRemoveRepeaterField = (index) => {
        const repeaterFields = [...props.attributes[attributeKey]];
        repeaterFields.splice(index, 1);
        props.setAttributes({ [attributeKey]: repeaterFields });
    };
    
    const handleAddTag = (index) => {
        const repeaterFields = [...props.attributes[attributeKey]];
        repeaterFields[index] = {
            ...repeaterFields[index],
            tags: [...repeaterFields[index]?.tags, ''],
        };
        props.setAttributes({ [attributeKey]: repeaterFields });
    };
    
    const handleRepeaterTagTextChange = (text, index, tagIndex) => {
        const repeaterFields = [...props.attributes[attributeKey]];
        repeaterFields[index] = {
            ...repeaterFields[index],
            tags: repeaterFields[index]?.tags.map((tag, i) =>
                i === tagIndex ? text : tag
            ),
        };
        props.setAttributes({ [attributeKey]: repeaterFields });
    };
    
    const handleRemoveTag = (index, tagIndex) => {
        const repeaterFields = [...props.attributes[attributeKey]];
        repeaterFields[index] = {
            ...repeaterFields[index],
            tags: repeaterFields[index]?.tags.filter((tag, i) => i !== tagIndex),
        };
        props.setAttributes({ [attributeKey]: repeaterFields });
    };

    if ( props.attributes[attributeKey].length ) {
        repeaterFields = props.attributes[attributeKey].map( ( value, index ) => {

            var repeaterFieldTags = props.attributes[attributeKey][ index ] ? props.attributes[attributeKey][ index ].tags.map( ( tag, tagIndex ) => {
                return <div className={'repeater-tags'} key={ tagIndex }>
                    <TextControl
                        placeholder="..."
                        value={ props.attributes[attributeKey][ index ].tags[ tagIndex ] }
                        onChange={ ( text ) => handleRepeaterTagTextChange( text, index, tagIndex ) }
                    />
                    <IconButton
                        icon="no-alt"
                        label={"Ta bort " + label}
                        onClick={ () => handleRemoveTag( index, tagIndex) }
                    />
                </div>;
            }) : null;

            return <div className={'repeater-tags-container'} key={ index }>


                <label for="">Ange attributnamn:</label>
                <div class="repeater-tag-item-name">
                    <TextControl
                        placeholder="..."
                        value={ props.attributes[attributeKey][ index ].label }
                        onChange={ ( text ) => handleRepeaterFieldChange( text, index ) }
                    />

                    <div class="icon">
                        <IconButton
                            icon="no-alt"
                            label={"Ta bort " + label}
                            onClick={ () => handleRemoveRepeaterField( index ) }
                        />
                    </div>
                </div>
                
                
                <div class="repeater-tags-list">
                    Värden: 
                    {repeaterFieldTags}

                    <Button
                        onClick={ () => handleAddTag( index ) }
                    >Lägg till värde</Button>
                </div>
                
                
            </div>;
        } );
    }

    return (
        <Panel>
            <PanelBody title={ label }>
            { repeaterFields }
                <Button
                    isDefault
                    onClick={ handleAddRepeaterField.bind( this ) }
                >
                    { 'Lägg till ' + label }
                </Button>
            </PanelBody>
        </Panel>
    );

}